import api from './APIService';

class LanguageService {
	getCurrent() {
		return api.fetch({ method: 'get', path: '/langs/current'});
	}
	postSetSession(data) {
		return api.fetch({ method: 'post', path: '/langs/setSession', data });
	}
	getAvailable() {
		return api.fetch({ method: 'get', path: '/langs/available' });
	}
}

export default new LanguageService();
